import * as Excel from 'exceljs/dist/exceljs.min'
import {
	saveAs
} from 'file-saver'

class ChartXDownloader {

	/**
	 * XDownloader
	 */

	addDownload(chartId){
		this.generateExcel(chartId)
	}

	generateExcel(chartId){
		const table = document.querySelector('#chartTableHidden');
		this.createWorkbook(table,chartId);
	}

	createWorkbook(table,chartId) {
		const name = NSContext.plugins.charts.config[chartId].config.get.chartname;
		const workbook = new Excel.Workbook();
		this.worksheet = 0;
		this.worksheet = workbook.addWorksheet(name);
		this.parseTable(table,chartId);
		this.parseFootnote(table);
		this.saveFile(name, workbook);
	}

	/**
	 * savefile doesnt need explanation as well
	 * @param {*} fileName
	 * @param {*} workbook
	 */
	async saveFile(fileName, workbook) {
		const xls64 = await workbook.xlsx.writeBuffer({
			base64: true
		})
		saveAs(
			new Blob([xls64], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			}),
			fileName
		)
	}

	parseFootnote(table) {
		const footnotes = Array.prototype.slice.call(table.querySelectorAll('.table-footnotes .chart-footnote'));
		this.worksheet.addRow([]);
		footnotes.forEach(fn => {
			this.worksheet.addRow([fn.innerText.replace('\n', ' ')]);
		});
	}

	parseTable(table,chartId) {
		const rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
		let row;
		let content = [];

		let counterR = 0;
		let counterC = 0;
		let first = true;

		let title = NSContext.plugins.charts.config[chartId].config.get.chartname;


		rows.forEach(r => {
			counterR++; //counters to keep track where you are
			counterC = 0;
			content = [];
			let tds;
			if(first){
				tds = Array.prototype.slice.call(r.querySelectorAll('td'));
				this.worksheet.columns = [
					{ header: '', key: '', width: 60 },
				];
				row = this.worksheet.lastRow;
				row.height = 0.5;
				if(title){
					this.worksheet.addRow([title]);
					row = this.worksheet.lastRow;

					row.getCell('A').font = {
						size: 16,
						bold: true
					};

					this.worksheet.addRow([]);
				}
			} else{
				tds = Array.prototype.slice.call(r.querySelectorAll('td'));
			}

			tds.forEach(t => { //second iteration for actual content
				counterC++;


				let c = this.correct(t.innerText);

				if (isNaN(c)) {
					c = c;
				} else {

					if (c == '\u00A0' || c.trim() == '') { //apparently this is still considered not NaN
						c = c;
					} else {
						c = parseFloat(c);
					}
				}

				content.push(c);
			});

			this.worksheet.addRow(content);

			row = this.worksheet.lastRow;

			if(first){
				first = false;
				for (let i = 1; i < (tds.length + 1); i++) {
					row.getCell(i).font = {
						bold: true
					};
					row.getCell(i).border = {
						bottom: {
							style: 'thin',
							color: {
								argb: 'FFB3AEA6'
							}
						}
					};
					row.getCell(i).fill = {
						type: 'pattern',
						pattern: 'solid',
						fgColor: {
							rgb: 'FFFFFFFF'
						}
					}
				}
			} else{
				row.getCell(1).font = {
					bold: true
				}
				for (let i = 1; i < (tds.length + 1); i++) {
					row.getCell(i).border = { bottom: {
							style: 'thin',
							color: {
								argb: 'FFB3AEA6'
							}
						}
					};
					row.getCell(i).fill = {
						type: 'pattern',
						pattern: 'solid',
						fgColor: {
							rgb: 'FFFFFFFF'
						}
					}
				}
			}
		});
	}

	correct(text) {
		return text.replace(/'/g, '').replace(/(?:\r\n|\r|\n)/g, '\n').replace(/’/g, '').replace(/–/g, '-').replace(/–/g, '-');
	}

}
export default new ChartXDownloader();
